import React from "react";
import SEO from "@/components/SEO";
import { Hero } from "@/components/sections/Hero";
import { ServicesOverview } from "@/components/sections/ServicesOverview";
import { EventPhotography } from "@/components/sections/EventPhotography";
import { PhotoSales } from "@/components/sections/PhotoSales";
import { VideoProduction } from "@/components/sections/VideoProduction";
import { HowCreditsWork } from "@/components/sections/HowCreditsWork";
import { FeaturedEvents } from "@/components/sections/FeaturedEvents";
import { WhyChooseUs } from "@/components/sections/WhyChooseUs";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { ApertureDivider } from "@/components/effects/ApertureDivider";

export default function Home() {
  return (
    <div data-testid="page-home">
      <SEO title="WelkomBiz Photography — Capturing Moments in Timeless Elegance" description="Premium event photography in Welkom and the Goldfields. Sports, corporate, weddings, matric farewells, baby showers and more." canonicalPath="/" />
      <Hero />
      <ServicesOverview />
      <ApertureDivider />
      <EventPhotography />
      <PhotoSales />
      <ApertureDivider />
      <VideoProduction />
      <HowCreditsWork />
      <ApertureDivider />
      <FeaturedEvents />
      <WhyChooseUs />
      <FinalCTA />
    </div>
  );
}
